import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const usePrompt = (message, when) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isBlocked = useRef(false); // Flag to track if the navigation was confirmed

  useEffect(() => {
    if (!when) return;

    // Handle the "beforeunload" event for tab refresh or close
    const handleBeforeUnload = (event) => {
      if (isBlocked.current) return;
      event.preventDefault();
      event.returnValue = message; // Standard for most browsers to show a prompt
    };

    // Handle browser back/forward navigation
    const handlePopState = (event) => {
      if (isBlocked.current) return; // Skip if navigation was already confirmed

      const userConfirmed = window.confirm(message); // Show confirmation dialog

      if (userConfirmed) {
        isBlocked.current = true; // Block further navigation and confirm the action
        navigate(-1); // Go to the previous page in the history stack
      } else {
        // Stay on the same page if the user cancels
        event.preventDefault(); // Prevent the default back navigation
      }
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.history.pushState(null, "", location.pathname); // Add a new history entry to intercept back navigation
    window.addEventListener("popstate", handlePopState);

    // Cleanup event listeners on component unmount or when `when` changes
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [message, when, navigate, location]);

  // Return the function to be used on the custom back button
  const handleCustomBackButton = () => {
    console.log(when)
    if (!when) {
      navigate("/");
    }else{
      if (isBlocked.current) return; // Skip if navigation was already confirmed

      const userConfirmed = window.confirm(message); // Show confirmation dialog
      console.log(userConfirmed)
      if (userConfirmed) {
        isBlocked.current = true; // Allow navigation
        navigate("/"); // Navigate to the previous page
      }
    }
  };

  return { handleCustomBackButton };
};

export default usePrompt;
